module.exports = __webpack_public_path__ + "img/Picture17.e391eac5.jpg";